// @flow
export default 'BROWSER';
